import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TooltipContent from './TooltipContent';
import {
  TooltipWrapper,
  HoverElement
} from './Tooltip.styles';

const Tooltip = ({ children, className, direction, persist }) => {
  const [show, showTooltip] = useState(false);
  const [position, setPosition] = useState();

  const onEnter = (e, force) => {
    if (show) return;
    if (persist && !force) return;
    try {
      const el = e.target;
      const isIE = !el.closest;
      const tooltipEl = isIE ? el : el.closest('.tooltip-element');
      const targetEl = tooltipEl && !isIE ? tooltipEl.firstChild : tooltipEl;
      const rect = targetEl.getBoundingClientRect();
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      const scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
      setPosition({
        rect,
        scrollTop,
        scrollLeft
      });
      showTooltip(true);
    } catch (err) {
      // do nothing on error
    }
  };

  const blockClick = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const closeTooltip = (e, force) => {
    if (persist && !force) return;
    showTooltip(false);
  };

  return (
    <TooltipWrapper
      onClick={blockClick}
      onMouseEnter={onEnter}
      onTouchStart={onEnter}
      onMouseLeave={closeTooltip}
      onMouseDown={e => onEnter(e, true)}
      className={className}
      direction={direction}
    >
      {React.Children.map(children, child =>
        React.cloneElement(child, { show, position, closeTooltip, direction, persist })
      )}
    </TooltipWrapper>
  );
};

Tooltip.Content = TooltipContent;
Tooltip.HoverElement = HoverElement;

Tooltip.defaultProps = {
  className: '',
  direction: 'up',
  persist: false
};

Tooltip.propTypes = {
  /** Tooltip should have two children: Tooltip.HoverElement and Tooltip.Content */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  direction: PropTypes.string,
  persist: PropTypes.bool
};

export default Tooltip;
